import { MeetingRoom } from "@mui/icons-material";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { ClientAppEvent } from "constants/index";
import { useAuthContext, useRoleContext } from "hooks";

export function LogoutButton() {
  const postHog = usePostHog();
  const { company, role } = useRoleContext();
  const { signout: signOut, user } = useAuthContext();

  const handleLogout = () => {
    postHog?.capture(
      ClientAppEvent.USER_SIGNED_OUT,
      {
        user_id: user?.id,
        role: role?.type,
        company_type: company?.company_type,
      },
      { send_instantly: true },
    );
    signOut();
  };

  return (
    <Tooltip title="Log Out" placement="bottom" TransitionComponent={Zoom}>
      <IconButton color="inherit" aria-label="Log Out" onClick={handleLogout}>
        <MeetingRoom fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}
